import styled from "styled-components"

const MainCategoryContainerStyled = styled.div`
    position: relative;
    padding: 50px 10px;
    
`

const CategoryContainerStyled = styled.div`
    position: relative;
    font-family: "";
    margin-bottom: 30px;
`

const CategoryHeaderStyled = styled.div`
    position: relative;
    margin-bottom: 15px;
    font-family:  "";
    font-size: 20px;
    margin-top: 40px;
    text-transform: uppercase;
    text-align: left;
`

const CategoryHeaderArStyled = styled(CategoryHeaderStyled)`
    text-align: right;
    font-family: "";
    //add the arabic font here later
`

const CategorySubHeaderStyled = styled.div`
    position: relative;
    margin-bottom: 15px;
    font-family:  "";
    font-size: 15px;
    text-transform: uppercase;
    text-align: left;
`

const CategorySubHeaderArStyled = styled(CategorySubHeaderStyled)`
    text-align: right;

    //add the font here later
`

const CategoryGridStyled = styled.div`
    position: relative
`

const ItemContainerStyled = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 3px;
`

const ItemImageContainer = styled.div`
    position: relative;
    width: 100%;

    img {
        width: 100%;
    }
`

const ItemBoxTwoStyled = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    line-height: 12px;
    font-size: 11px;

`
const ItemDetailsContainer = styled.div`
    position: relative;
    width: 70%;
`



const ItemPriceContainer = styled.div`
    position: relative;
    font-family: "";
    padding-right: 3px;
    font-family: "Courier New Bold";

    span {
        font-size: 8px;
    }
`

const ItemPriceContainerAr = styled(ItemPriceContainer)`
    padding-left: 3px;
    display: flex;
    gap: 4px;
    flex-direction: row-reverse;
    justify-content: flex-start;
`

const ItemNameStyled = styled.span`
    font-family: "Courier New Bold";
    font-size: 9px;
    text-align: left;
`

const ItemDetailsStyled = styled.span`
    font-family: "Courier New";
    font-size: 9px;

`

const ItemNameArStyled = styled(ItemNameStyled)`
    font-family: "";
`

const ItemDetailsArStyled = styled.span`
    font-family: "";
`

const CopyRightStyled = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    padding: 40px 0px;
    width: 100%;
    img {
        width: 45%;
    }
`

export {
    MainCategoryContainerStyled,
    CategoryContainerStyled,
    CategoryHeaderStyled,
    CategoryHeaderArStyled,
    CategorySubHeaderStyled,
    CategorySubHeaderArStyled,
    CategoryGridStyled,
    ItemContainerStyled,
    ItemImageContainer,
    ItemBoxTwoStyled,
    ItemDetailsContainer,
    ItemDetailsStyled,
    ItemDetailsArStyled,
    ItemPriceContainer,
    ItemPriceContainerAr,
    ItemNameStyled,
    ItemNameArStyled,
    CopyRightStyled,
}